import { withSBErrorHandling } from '../types';
import { ScanbotSDKPlugin } from './Definitions';
/**
 * @internal
 * @hidden
 */
export const ScanbotPdfImageExtractorImpl = {
    async extractImageFiles(params) {
        return withSBErrorHandling(async () => {
            return (await ScanbotSDKPlugin.extractImageFilesFromPdf(params)).result;
        });
    },
};
//# sourceMappingURL=PdfImageExtractorImpl.js.map